"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class FilterValue {
    constructor(type = 'empty') {
        this.type = type;
    }
    static newEmpty() {
        return new FilterValue();
    }
    static newBoolean(bool) {
        const fv = new FilterValue('boolean');
        fv.boolean_value = bool;
        return fv;
    }
    static newNumber(num) {
        const fv = new FilterValue('number_simple');
        fv.number_value = num;
        return fv;
    }
    static newNumberRange(a, b) {
        const fv = new FilterValue('number_range');
        fv.number_from = a;
        fv.number_to = b;
        return fv;
    }
    static newDate(d) {
        const fv = new FilterValue('date_simple');
        fv.date_value = d;
        return fv;
    }
    static newDateRange(a, b) {
        const fv = new FilterValue('date_range');
        fv.date_from = a;
        fv.date_to = b;
        return fv;
    }
    static newList(items) {
        const fv = new FilterValue('list');
        fv.item_list = items;
        return fv;
    }
}
exports.default = FilterValue;
